import { render, staticRenderFns } from "./custom2.vue?vue&type=template&id=83cb8d92&scoped=true"
import script from "./custom2.vue?vue&type=script&lang=js"
export * from "./custom2.vue?vue&type=script&lang=js"
import style0 from "./custom2.vue?vue&type=style&index=0&id=83cb8d92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cb8d92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83cb8d92')) {
      api.createRecord('83cb8d92', component.options)
    } else {
      api.reload('83cb8d92', component.options)
    }
    module.hot.accept("./custom2.vue?vue&type=template&id=83cb8d92&scoped=true", function () {
      api.rerender('83cb8d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom2.vue"
export default component.exports